import type { ValueOf } from '../../../../types/util';
import type { IngestionStatusMap, ReviewStatus, TranscodeStatusMap } from '../constants';
import type { LabelType } from '../util/LabelType';

export enum StageLabels {
  Ingest = 'INGEST',
  Transcode = 'TRANSCODE',
  Review = 'REVIEW',
}

type IngestLabel = {
  stage: StageLabels.Ingest;
  label: ValueOf<typeof IngestionStatusMap>;
  type: ValueOf<typeof LabelType>;
};

type TranscodeLabel = {
  stage: StageLabels.Transcode;
  label: ValueOf<typeof TranscodeStatusMap>;
  type: ValueOf<typeof LabelType>;
};

type ReviewLabel = {
  stage: StageLabels.Review;
  label: ValueOf<typeof ReviewStatus>;
  type: ValueOf<typeof LabelType>;
};

export type StatusLabel = IngestLabel | TranscodeLabel | ReviewLabel | null;
